<template>
  <van-dialog v-model:show="showNotify" :confirm-button-text='$t("close")' confirm-button-color="#007AFF"
    class="metfone-dialog" @confirm="handleCloseApp">
    <template #title>
      <div class="metfone-dialog-title"> {{ $t("sorry") }}</div>
    </template>
    <template #default>
      <div class="metfone-dialog-description" v-if="dataMessage"> {{ dataMessage.message }}</div>
    </template>
  </van-dialog>
</template>
<script>

import { Dialog } from 'vant';


export default {
  name: "GlobalNotify",
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    dataMessage: {
      type: Object,
      required: true,
      default: null
    }
  },
  data() {
    return {
      showNotify: false
    }
  },
  created() {

  },
  watch: {
    isShow() {
      this.showNotify = this.isShow;
    }
  },
  mounted() {
    this.showNotify = this.isShow;
  },
  methods: {
    handleCloseApp() {
      this.$emit("update:isShow", false)
    }
  }
}
</script>

<style>
.metfone-dialog-title {
  color: #000;
  text-align: center;
  font-family: SF Pro Text;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
}

.metfone-dialog-description {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  color: #000;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.078px;
  /* //padding-bottom: 16px; */
  padding-right: 16px;
  padding-left: 16px;
}
</style>
